import { render, staticRenderFns } from "./AttachmentsBox.vue?vue&type=template&id=050ab6c6&"
import script from "./AttachmentsBox.vue?vue&type=script&lang=js&"
export * from "./AttachmentsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports